import React from 'react';
import injectSheet from 'react-jss';

import { compose } from 'shared/helpers';

import { mixClasses as cx } from 'helpers';


const AboutThis = ({
  classes: cn,
}) => (
  <div className={cx(cn.root)}>
    <div className={cx(cn.hero)}>
      <div className={cx(cn.headline, 'white ttu')}>
        <span >
          What is this? Why does this exist?
        </span>
      </div>
    </div>
    <div >
      Something else blahblah
    </div>
  </div>
);
const styles = {
  root: { },
  hero: {
    // background: 'grey',
    background: 'linear-gradient(125deg, #062849, #1d5f5c)',
  },
  headline: {
    height: '500px',
  },
};


export default compose(
  injectSheet(styles),
)(AboutThis);



// WEBPACK FOOTER //
// ./src/pages/about/AboutThis.js